import axios from 'axios';
import getApiBaseUrl from '../GetServer';

// Interfaz para el payload que se enviará al backend.
// Coincide con la clase `EditClient` que espera tu endpoint.
export interface NewClientPayload {
    Nombre: string;
    Email: string;
    Telefono: string;
    Status: number; // 0 para inactivo, 1 para activo
}

// Interfaz para la respuesta esperada del backend
interface BackendResponse {
    status: number;
    message: string;
}

export const createClient = async (payload: NewClientPayload): Promise<BackendResponse> => {
    try {
        const baseUrl = getApiBaseUrl();
        const endpoint = `${baseUrl}dash/new-client`;
        const token = localStorage.getItem('token');

        if (!token) {
            throw new Error('Token de autorización no disponible');
        }

        const response = await axios.post<BackendResponse>(endpoint, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        return response.data;
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || 'Ocurrió un error al crear el cliente.';
        console.error('Error en createClient:', errorMessage, error);
        throw new Error(errorMessage);
    }
};

